import { css } from '@emotion/react';

const googleButtonCss = css`
  /* Base button styles */
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: #2a2a2a;
  background-image: none;
  border: 1px solid #444;
  border-radius: 4px;
  box-sizing: border-box;
  color: #e0e0e0;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 16px;
  height: 42px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  margin: 8px 0;

  /* State overlay */
  .gsi-material-button-state {
    transition: opacity 0.218s;
    bottom: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  /* Content wrapper */
  .gsi-material-button-content-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    justify-content: center;
    position: relative;
    width: 100%;
  }

  /* Google icon */
  .gsi-material-button-icon {
    height: 24px;
    margin-right: 12px;
    min-width: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Text span */
  .gsi-material-button-contents {
    font-family: 'Roboto', arial, sans-serif;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    line-height: 1;
  }

  /* Disabled state */
  &:disabled {
    cursor: default;
    background-color: #1a1a1a;
    border-color: #333;
  }

  &:disabled .gsi-material-button-state {
    background-color: #1f1f1f1f;
  }

  &:disabled .gsi-material-button-contents,
  &:disabled .gsi-material-button-icon {
    opacity: 38%;
  }

  /* Focus/active states */
  &:not(:disabled):active .gsi-material-button-state,
  &:not(:disabled):focus .gsi-material-button-state {
    background-color: #6ab0f3;
    opacity: 12%;
  }

  /* Hover state */
  &:not(:disabled):hover {
    background-color: #3a3a3a;
    border-color: #555;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3),
                0 1px 3px 1px rgba(0, 0, 0, 0.15);
  }

  &:not(:disabled):hover .gsi-material-button-state {
    background-color: #6ab0f3;
    opacity: 8%;
  }
`;

export default function GoogleSignInButton({ text = 'Sign in', ...props }) {
  return (
    <button css={googleButtonCss} {...props}>
      <div className="gsi-material-button-state"></div>
      <div className="gsi-material-button-content-wrapper">
        <div className="gsi-material-button-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            style={{ display: 'block' }}
          >
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
            <path fill="none" d="M0 0h48v48H0z" />
          </svg>
        </div>
        <span className="gsi-material-button-contents">{`${text} with Google`}</span>
        {/* Hidden fallback text for screen readers, etc. */}
        <span style={{ display: 'none' }}>{`${text} with Google`}</span>
      </div>
    </button>
  );
}
